<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
                <div class="header-block">
                    <div class="header-title">
                        <p>Update Param Value</p>
                    </div>
                    <div class="add-block">
                        
                    </div>
                </div>
                <div [formGroup]="form">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">
                            <div class="form-group">
                                <!-- <input formControlName="key" type="text" placeholder="enter param key" class="form-control"> -->
                                <select class="form-control" formControlName="key">
                                    <option *ngFor="let param of paramData" [value]="param.name">{{param.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <div class="form-group">
                                <input formControlName="value" placeholder="enter param value" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-12 update-btn">
                            <button (click)="update()">Update Value</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
